export default __webpack_public_path__ + "static/media/Zone-Master-Plan-Type-E.3ac7d350.png";